var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.666H2C1.72667 18.666 1.5 18.4393 1.5 18.166C1.5 17.8927 1.72667 17.666 2 17.666H14C14.2733 17.666 14.5 17.8927 14.5 18.166C14.5 18.4393 14.2733 18.666 14 18.666Z",
    fill: "#353546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6804 6.32043C11.387 5.0271 10.1204 4.99376 8.79371 6.32043L7.98704 7.1271C7.92037 7.19376 7.89371 7.30043 7.92038 7.39376C8.42704 9.16043 9.84037 10.5738 11.607 11.0804C11.6337 11.0871 11.6604 11.0938 11.687 11.0938C11.7604 11.0938 11.827 11.0671 11.8804 11.0138L12.6804 10.2071C13.3404 9.55376 13.6604 8.92043 13.6604 8.28043C13.667 7.62043 13.347 6.98043 12.6804 6.32043Z",
    fill: "#353546"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4075 11.6865C10.2142 11.5932 10.0275 11.4999 9.84753 11.3932C9.70086 11.3065 9.56086 11.2132 9.42086 11.1132C9.30753 11.0399 9.1742 10.9332 9.04753 10.8265C9.0342 10.8199 8.98753 10.7799 8.9342 10.7265C8.7142 10.5399 8.46753 10.2999 8.24753 10.0332C8.22753 10.0199 8.1942 9.9732 8.14753 9.9132C8.08086 9.8332 7.96753 9.69987 7.86753 9.54654C7.78753 9.44654 7.6942 9.29987 7.60753 9.1532C7.50086 8.9732 7.40753 8.7932 7.3142 8.60654C7.19182 8.34431 6.84766 8.26641 6.64304 8.47103L2.8942 12.2199C2.80753 12.3065 2.72753 12.4732 2.70753 12.5865L2.34753 15.1399C2.28086 15.5932 2.40753 16.0199 2.68753 16.3065C2.92753 16.5399 3.26086 16.6665 3.62086 16.6665C3.70086 16.6665 3.78086 16.6599 3.86086 16.6465L6.42086 16.2865C6.54086 16.2665 6.70753 16.1865 6.78753 16.0999L10.5426 12.3448C10.7431 12.1443 10.6677 11.7993 10.4075 11.6865Z",
    fill: "#353546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.58cfd2e7aa86add37eea5d6d48ca0cf6.svg";
export { ForwardRef as ReactComponent };